import { MuiAlert, type MuiAlertColor, MuiSnackbar } from '@/components/mui';
import { useErrorStore } from '@/stores/errorStore';

const getAlertSeverity = (type: string): MuiAlertColor => {
  switch (type) {
    case 'error':
      return 'error';
    case 'warning':
      return 'warning';
    case 'info':
      return 'success';
    default:
      return 'info';
  }
};

export function ErrorToast() {
  const currentError = useErrorStore((state) => state.currentError);
  const isToastOpen = useErrorStore((state) => state.isToastOpen);
  const dismiss = useErrorStore((state) => state.dismiss);

  if (!currentError) return null;

  const severity = getAlertSeverity(currentError.type);

  return (
    <MuiSnackbar
      open={isToastOpen}
      autoHideDuration={currentError.duration}
      onClose={dismiss}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 1 }}
    >
      <MuiAlert
        onClose={dismiss}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        {currentError.title && currentError.title !== currentError.message && <strong>{currentError.title}: </strong>}
        {currentError.message}
      </MuiAlert>
    </MuiSnackbar>
  );
}
